import { render } from "./StoreList.vue?vue&type=template&id=8501b8bc"
import script from "./StoreList.vue?vue&type=script&lang=js"
export * from "./StoreList.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./StoreList.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_9073b6d4%2Fpackages%2Finsurer%2Fsrc%2Fviews%2Fmerchants%2FStoreList.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__